import "./App.scss";

import { useEffect, useState } from "react";

//Components Import
import StudentCard from "./Components/StudentCard";
import Searchbar from "./Components/Searchbar";

function App() {
    const [results, setResults] = useState([]);
    const [students, setStudents] = useState([]);

    const [searchName, setSearchName] = useState("");
    const [searchTag, setSearchTag] = useState("");

    useEffect(() => {
        let data = fetch("https://api.hatchways.io/assessment/students")
            .then((response) => response.json())
            .then((data) => {
                setResults(data.students);
                setStudents(data.students);
            });

        return data;
    }, []);

    useEffect(() => {
        let filteredResults = results.filter((result) => {
            const name = result.firstName + " " + result.lastName;
            const tags =
                result.tag !== undefined ? result.tag.toString() : false;

            if (searchName !== "" && searchTag === "") {
                return name.toLowerCase().includes(searchName.toLowerCase());
            } else if (searchName === "" && searchTag !== "") {
                return typeof tags === "string"
                    ? tags.toLowerCase().includes(searchTag.toLowerCase())
                    : false;
            } else if (searchName !== "" && searchTag !== "") {
                const isName = name
                    .toLowerCase()
                    .includes(searchName.toLowerCase());
                const isTag =
                    typeof tags === "string"
                        ? tags.toLowerCase().includes(searchTag.toLowerCase())
                        : false;

                return isName && isTag;
            } else if (searchName === "" && searchTag === "") {
                return true;
            }
            return false;
        });

        setStudents(filteredResults);
    }, [searchName, searchTag, results]);

    const updateStudent = (obj) => {
        students.forEach((student) => {
            if (student.id === obj.id) student.tag = obj.tag;
        });

        results.forEach((res) => {
            if (res.id === obj.id) res.tag = obj.tag;
        });
    };

    return (
        <div className="App">
            <Searchbar
                searchTerm={searchName}
                setSearchTerm={setSearchName}
                placeholder={"Search by name..."}
            />

            <Searchbar
                searchTerm={searchTag}
                setSearchTerm={setSearchTag}
                placeholder={"Search by tag..."}
            />
            <div className="students">
                {students.map((result) => (
                    <StudentCard
                        data={result}
                        key={result.id}
                        updateStudent={updateStudent}
                    />
                ))}
            </div>
        </div>
    );
}

export default App;
